var render = function () {
  var _ref, _ref$format, _vm$user;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.$vuetify.breakpoint.mobile ? _c('floating-actions', {
    staticClass: "pr-4",
    attrs: {
      "right": "",
      "top": "",
      "bottom": ""
    }
  }, [_c('v-hover', {
    model: {
      value: _vm.hovers,
      callback: function callback($$v) {
        _vm.hovers = $$v;
      },
      expression: "hovers"
    }
  }, [_c('v-card', {
    staticClass: "quick-menu",
    class: {
      hovers: _vm.hovers
    },
    attrs: {
      "rounded": "xl"
    }
  }, [_c('img', {
    staticClass: "point",
    attrs: {
      "src": "/images/point.png"
    }
  }), _c('v-btn', {
    staticClass: "pa-0",
    attrs: {
      "text": "",
      "tile": "",
      "width": "80",
      "height": "80",
      "active-class": "no-active",
      "block": ""
    },
    on: {
      "click": function click($event) {
        _vm.hovers = !_vm.hovers;
      }
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', {
    staticClass: "d-block mx-auto",
    attrs: {
      "color": "grey",
      "size": "32"
    }
  }, [_vm.hovers ? [_vm._v(" mdi-chevron-right ")] : [_vm._v(" mdi-chevron-left ")]], 2)], 1)]), _vm.logoff ? _c('v-btn', {
    staticClass: "pa-0",
    attrs: {
      "text": "",
      "tile": "",
      "width": "80",
      "height": "80",
      "active-class": "no-active",
      "block": "",
      "to": "/login"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', {
    staticClass: "d-block mx-auto",
    attrs: {
      "color": "primary",
      "size": "32"
    }
  }, [_vm._v("mdi-lock-outline")]), _c('span', [_vm._v("로그인")])], 1)]) : _vm._e(), _vm.logoff ? _c('v-btn', {
    staticClass: "pa-0",
    attrs: {
      "text": "",
      "tile": "",
      "width": "80",
      "height": "80",
      "active-class": "no-active",
      "block": "",
      "to": "/join"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', {
    staticClass: "d-block mx-auto",
    attrs: {
      "color": "primary",
      "size": "32"
    }
  }, [_vm._v("mdi-account-plus-outline")]), _c('span', [_vm._v("회원가입")])], 1)]) : _vm._e(), _vm.logon ? _c('v-btn', {
    staticClass: "pa-0",
    attrs: {
      "text": "",
      "tile": "",
      "width": "80",
      "height": "80",
      "active-class": "no-active",
      "block": "",
      "to": "/mypage/cashes/inquiry"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', {
    staticClass: "d-block mx-auto",
    attrs: {
      "color": "primary",
      "size": "32"
    }
  }, [_vm._v("mdi-circle-multiple-outline")]), _vm.hovers ? [_c('span', [_vm._v(" " + _vm._s((_ref = ((_vm$user = _vm.user) === null || _vm$user === void 0 ? void 0 : _vm$user.cash) || 0) === null || _ref === void 0 ? void 0 : (_ref$format = _ref.format) === null || _ref$format === void 0 ? void 0 : _ref$format.call(_ref)) + " 원 ")])] : [_c('span', [_vm._v(" 보유캐시 ")])]], 2)]) : _vm._e(), _vm.logon ? _c('v-btn', {
    staticClass: "pa-0",
    attrs: {
      "text": "",
      "tile": "",
      "width": "80",
      "height": "80",
      "active-class": "no-active",
      "block": "",
      "to": "/mypage/cashes/charge"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', {
    staticClass: "d-block mx-auto",
    attrs: {
      "color": "primary",
      "size": "32"
    }
  }, [_vm._v("mdi-credit-card-plus-outline")]), _c('span', [_vm._v("캐시충전")])], 1)]) : _vm._e(), _c('v-btn', {
    staticClass: "pa-0",
    attrs: {
      "text": "",
      "tile": "",
      "width": "80",
      "height": "80",
      "active-class": "no-active",
      "block": "",
      "to": "/exchange"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', {
    staticClass: "d-block mx-auto",
    attrs: {
      "color": "primary",
      "size": "32"
    }
  }, [_vm._v("mdi-gift-outline")]), _c('span', [_vm._v("교환소")])], 1)]), _c('v-btn', {
    staticClass: "pa-0",
    attrs: {
      "text": "",
      "tile": "",
      "width": "80",
      "height": "80",
      "active-class": "no-active",
      "block": "",
      "to": "/mypage/shop/carts"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', {
    staticClass: "d-block mx-auto",
    attrs: {
      "color": "primary",
      "size": "32"
    }
  }, [_vm._v("mdi-cart-outline")]), _c('span', [_vm._v("장바구니")])], 1)]), _vm.logon ? _c('v-btn', {
    staticClass: "pa-0",
    attrs: {
      "text": "",
      "tile": "",
      "width": "80",
      "height": "80",
      "active-class": "no-active",
      "block": "",
      "to": "/mypage"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', {
    staticClass: "d-block mx-auto",
    attrs: {
      "color": "primary",
      "size": "32"
    }
  }, [_vm._v("mdi-account-outline")]), _c('span', [_vm._v("마이페이지")])], 1)]) : _vm._e(), _vm.logon ? _c('v-btn', {
    staticClass: "pa-0",
    attrs: {
      "text": "",
      "tile": "",
      "width": "80",
      "height": "80",
      "active-class": "no-active",
      "block": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('logout');
      }
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', {
    staticClass: "d-block mx-auto",
    attrs: {
      "color": "primary",
      "size": "32"
    }
  }, [_vm._v("mdi-lock-outline")]), _c('span', [_vm._v("로그아웃")])], 1)]) : _vm._e()], 1)], 1), _c('recent-products', {
    staticClass: "ml-auto mr-0 mt-4"
  })], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }